import React, { useCallback, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import Button from "components/atoms/Button";
import FormInput from "components/atoms/FormInput";
import PageTitle from "components/atoms/PageTitle";
import Select from "components/atoms/SelectInput";
import arrowLeft from "../../../assets/svg/larrow-left-long.svg";
import searchIcon from "../../../assets/svg/search-normal.svg";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getRequest,
  BASE_URL,
  loggedUser_baseURL,
  postRequest,
  putRequest,
} from "services/http";
import axios from "axios";
import { handleException } from "utils";
import Alert from "components/atoms/Alert";
import { setUserLoggedIn, } from "redux/auth/auth.action";
import { SET_USER_LOGGED_IN } from "redux/auth/auth.type";
import { updateBank, updateAccountNumber,updateBankName, RESET_FORM } from "redux/formAction";
import returnIcon from "../../../assets/svg/arrow-left.svg";
import Spinner from "components/atoms/Spinner";
import arrowUp from "../../../assets/svg/arrow-up.svg";
import arrowDown from "../../../assets/svg/arrow-down.svg";
import DropdownCard from "components/atoms/Dropdown/DropdownCard";
import { getValues } from "services/storage";

const SettlementInformation = (props) => {
  const [dropdown, setDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [skipPgLoader, setSkipPgLoader] = useState(false);
  const [loadingAcctData, setLoadingAcctData] = useState(false);
  const [showErr, setShowErr] = useState(false);
  const [selectInputVal, setSelectInputVal] = useState("");
  const [bankList, setBankList] = useState<any>([]);
  const { form } = useSelector((state: any) => state);
  const [selectedBank, setSelectedBank] = useState(form.selectedBank || "");
  const [selectedBankName, setSelectedBankName] = useState(form.selectedBankName || "");
  const [accountNum, setAccountNum] = useState(form.accountNum || "");
  const [accountName, setAccountName] = useState("");
  const [countries, setCountries] = useState<any>([]);

  const [accountNumErr, setAccountNumErr] = useState("");
  const [pageNum, setPageNum] = useState(null);
  const [recordsPerPage] = useState(10);

  const navigate = useNavigate();
  const location = useLocation();

  const profileStatus_kyc =
    location?.state?.profileStatus?.step2 === "COMPLETED" ? true : false;

  const formComplete = "";
  const disabledBtn = !formComplete || loading;
  const inputNum = /^[0-9]*$/;
  const inputAlpha = /^[a-zA-Z ]*$/;
  const inputAlphaNum = /^[a-zA-Z0-9._-]*$/;

  const dispatch = useDispatch();

  const dispatchToStore = useCallback(() => {
    dispatch(updateAccountNumber(accountNum));
    dispatch(updateBank(selectedBank));
    dispatch(updateBankName(selectedBankName))
  }, [dispatch, selectedBank, accountNum, selectedBankName]);

  useEffect(() => {
    dispatchToStore();
  }, [dispatchToStore]);

  const partnerCountry = countries?.find((c: { name: string }) => {
    const userCountry = props?.authData?.country;
    return (
      typeof userCountry === "string" &&
      c?.name?.toLowerCase() === userCountry.toLowerCase()
    );
  });
  
  const fetchAccount = async () => {
    setLoadingAcctData(true);
    const headers = {
      "Content-Type": "application/json",
    };
    const body = {
      bankcode: selectedBank,
      accountnumber: accountNum,
    };
    const res = await postRequest(
      "https://pocket.seerbitapi.com/pocket/authenticate/name-enquiry",
      headers,
      body
    );

    // New name enquiry endpoint
    if (res?.data?.data?.code === "00") {
      setLoadingAcctData(false);
      setAccountName(res?.data.data.cutomername);
    } else {
      setLoadingAcctData(false);
      setAccountName("");
    }
  };
   const bearerToken =  useSelector((state: any) => state.auth.user_authData?.token?.token) ||
    location?.state?.token || 
    getValues("auth_token"); 
    
  const fetchBanks = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearerToken}`,
    };
    const res = await getRequest(
      `${BASE_URL + loggedUser_baseURL}banks/${
        partnerCountry?.countryCode
      }?page=${pageNum === null ? 0 : pageNum}&size=${recordsPerPage}&p`,
      headers
    );

    if (res?.data.responseCode === "00") {
      setBankList(res?.data.data);
    } else {
      Alert("error", res?.data.message);
    }
  };

  const getCountries = async () => {
    const res = await getRequest(process.env.REACT_APP_COUNTRIES_URL!);

    if (res?.status === 200) {
      setCountries(res?.data.payload);
    }
  };

  useEffect(() => {
    if (form.selectedBankName) {
      setSelectInputVal(form.selectedBankName);
      setSelectedBankName(form.selectedBankName);
    }
    if (form.selectedBank) {
      setSelectedBank(form.selectedBank);
    }
  }, [form.selectedBank, form.selectedBankName]);
  

  const handleSelect = (item) => {
    setSelectedBank(item.bank_nip_code);
    setSelectInputVal(item.bank_name);
    setSelectedBankName(item.bank_name)
    setDropdown(false);
  };

  const filteredData = bankList?.filter((item) => {
    if (item.bank_name.toLowerCase().includes(selectInputVal.toLowerCase())) {
      return item;
    } else {
      return;
    }
  });

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${props.bearerToken}`,
  };

  const verifyKYC = async (reqData: any) => {
    setSkipPgLoader(true);

    const res = await putRequest(
      `${BASE_URL + loggedUser_baseURL}update`,
      headers,
      reqData
    );

    if (res?.data.responseCode === "00") {
      Alert("success", res?.data.message);
      props.setUserLoggedIn(true);
      setSkipPgLoader(false);
    } else {
      setSkipPgLoader(false);
    }
  };

  const verifyKYCandSettlementInfo = async (requestData: any) => {
    setLoading(true);

    const res = await putRequest(
      `${BASE_URL + loggedUser_baseURL}update`,
      headers,
      requestData
    );

    if (res?.data.responseCode === "00") {
      Alert("success", res?.data.message);
      props.setUserLoggedIn(true);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const reqData = {
      settlement_account: {
        payout_account_number: accountNum,
        payout_account_name: accountName,
        payout_bank_code: selectedBank,
        payout_bank_name: selectInputVal,
      },
    };

    // if (profileStatus_kyc) {
    // 	verifyKYCandSettlementInfo(reqData);
    // } else {
    verifyKYCandSettlementInfo({
      ...reqData,
      address: location.state?.address,
      kycDoc: location.state?.kycInfo?.value,
      emails: location.state?.emails,
      ...(partnerCountry?.countryCode === "NG"
        ? { bvn: location.state?.bvn }
        : {}),
    });
    dispatch({ type: RESET_FORM });
    // }
  };

  const skipFunc = () => {
    if (
      location.state?.address?.street !== "" &&
      location.state?.address?.city !== "" &&
      location.state?.address?.state !== "" &&
      location.state?.kycInfo?.value.length > 0
    ) {
      verifyKYC({
        address: location.state?.address,
        kycDoc: location.state?.kycInfo?.value,
        emails: location.state?.emails,
        ...(partnerCountry?.countryCode === "NG"
          ? { bvn: location.state?.bvnId }
          : {}),
      });
    } else {
      // Alert('success', 'Login was successful');
      props.setUserLoggedIn(true);
    }
  };

  useEffect(() => {
    if (countries.length > 0) {
      fetchBanks();
    } else {
      getCountries();
    }
  }, [countries]);

  useEffect(() => {
    if (selectedBank && accountNum.length === 10) fetchAccount();
  }, [selectedBank, accountNum]);

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col w-full max-w-sm gap-7"
    >
      <div className="flex flex-col gap-0">
        <span
          className="flex items-center gap-1 text-sm font-normal cursor-pointer"
          onClick={() => navigate("/auth/emails_info")}
        >
          <img src={returnIcon} alt="return" className="w-[11px] h-[11px]" />
          Back
        </span>
        <PageTitle
          pageTitle="Enter Settlement Information"
          pageTitleStyle="font-semibold !text-2xl tablet:!text-xl"
          subTitle="Settlement is the transfer of funds from SeerBit to your bank account."
          subTitleStyle="!text-sm leading-7 !text-Black2"
        />
      </div>

      <div className="flex flex-col gap-3">
        <div className="w-full relative z-[22]">
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold leading-6 text-Black2">
              Banks
            </label>
            <div
              className="flex items-center justify-between w-full bg-white border border-transparent rounded-md cursor-pointer text-Black2"
              onClick={() => setDropdown((prevState) => !prevState)}
            >
              <span className="w-full p-2">
                {selectInputVal === ""
                  ? "Select Bank"
                  : selectInputVal.length > 35
                  ? selectInputVal.slice(0, 35) + "..."
                  : selectInputVal}
              </span>
              <img
                src={dropdown ? arrowUp : arrowDown}
                alt=""
                className="w-4 h-4 mx-4 cursor-pointer"
              />
            </div>
          </div>

          {dropdown && (
            <DropdownCard
              handleClickOut={setDropdown}
              cardLayout={`min-w-[150px] w-3/4 max-h-[250px] flex flex-col gap-0 absolute z-20 right-0 top-20 p-1 bg-white rounded-md shadow-[0_8px_30px_rgb(0,0,0,0.12)] h-fit animate-slide_down2`}
            >
              <FormInput
                type="text"
                // name='banks'
                placeholder="Select Bank"
                style={` w-full relative z-[15]`}
                inputStyle={`border border-transparent text-Black2 w-full bg-white`}
                value={selectInputVal}
                onChange={(e) => {
                  setSelectInputVal(e.target.value);
                  if (e.target.value.length >= 1) {
                    setDropdown(true);
                  } else {
                    setDropdown(false);
                  }
                }}
                img={searchIcon}
                imgStyle="w-4 h-4"
              />
              <div className="flex flex-col gap-0 overflow-scroll">
                {filteredData?.length === 0 ? (
                  <span className="p-2 text-sm font-normal leading-6 rounded-md cursor-default text-Primary hover:bg-BackDrop_d_xs">
                    Not found
                  </span>
                ) : (
                  filteredData?.map((item, i) => (
                    <span
                      key={i}
                      onClick={() => handleSelect(item)}
                      className="p-2 text-sm font-normal leading-6 rounded-md cursor-pointer text-Black2 hover:bg-BackDrop_d_xs"
                    >
                      {item.bank_name}
                    </span>
                  ))
                )}
              </div>
            </DropdownCard>
          )}
        </div>

        <FormInput
          type={"text"}
          name="account_number"
          placeholder="Enter Account Number"
          style="w-full"
          inputStyle="border border-transparent text-Black2"
          label="Account Number"
          labelStyle="font-semibold text-sm leading-6 text-Black2"
          value={accountNum}
          validationErr={showErr && accountNumErr}
          onChange={(e) => {
            if (inputNum.test(e.target.value)) setAccountNum(e.target.value);

            if (e.target.value.length !== 10) {
              setAccountNumErr("Invalid Account number");
              setShowErr(true);
            }

            setTimeout(() => {
              setShowErr(false);
            }, 3000);
          }}
        />

        <div className="">
          <p className="mb-2 text-sm font-semibold leading-6 text-Black2">
            Account name
          </p>
          <div
            className={`rounded-lg px-3 py-2 text-sm bg-SecondaryAccent5 border border-SecondaryAccent5 text-gray-600`}
          >
            {loadingAcctData ? (
              <div className="flex w-full gap-3 animate-pulse">
                <div className={`rounded h-5 w-3/6 bg-gray-300`}></div>
                <div className={`rounded h-5 w-2/6 bg-gray-300`}></div>
              </div>
            ) : (
              <span className={`${accountName === "" && "text-gray-400"}`}>
                {accountName ? (
                  <strong>{accountName}</strong>
                ) : (
                  "The account name is auto-generated"
                )}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-between">
        {/* <button onClick={skipFunc} className='text-red-500 border-none bg-none'>Skip</button> */}
        <Button
          btnType="button"
          btnText={skipPgLoader ? <Spinner text="Loading..." /> : "Skip"}
          btnStyle="text-red-500 bg-none border-none hover:shadow-none p-3 rounded-md"
          onClick={skipFunc}
        />
        <Button
          btnType="submit"
          btnText={loading ? "Loading..." : "Submit"}
          btnStyle={`${
            !accountName ? "cursor-not-allowed" : ""
          } bg-black text-white px-6 py-3 w-fit`}
          disabled={!accountName}
          onClick={() => {}}
        />
      </div>
    </form>
  );
};

const mapStateToProps = (state) => ({
  bearerToken: state.auth.user_authData?.token.token,
  authData: state.auth.user_authData,
  user_loggedIn: state.auth.user_loggedIn,
});

const mapDispatchToProps = (dispatch) => ({
  setUserLoggedIn: (data: boolean) => dispatch(setUserLoggedIn(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettlementInformation);
